angular.module('agreements')
    .component('agreementOrdersTable', {
        bindings: {
            projectId: '<',
            ids: '<',
            query: '<',
            includeConfidential: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/agreements/table-order.html',
        controller($scope, $state, Project, ProjectService, Agreement, AgreementService, AgreementConst, BusinessThread) {
            this.ProjectService = ProjectService;
            this.AgreementService = AgreementService
            this.filters = {}

            this.$onChanges = () => {
                this.filters.page = null
                this.load()
            }

            this.load = () => {
                if (angular.isArray(this.ids) && !this.ids.length) {
                    this.page = {list: [], fullListSize: 0, objectsPerPage: 50, pageNumber: 1}
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                    return
                }

                let params = angular.extend({}, this.filters, {
                    mainProject: this.projectId,
                    ids: this.ids,
                    filter: 'granted',
                    search: this.query
                })
                let resource = this.includeConfidential === true ? BusinessThread.agreementOrderTable : Agreement.tableOrder
                if (this.includeConfidential === true) {
                    params.includeConfidential = true
                }
                return resource(params).$promise.then(data => {
                    this.page = data;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                });
            }

            this.href = item => item && item.id ? $state.href('agreementShow', {id: item.id}) : null
            this.open = (event, id) => {
                if (event && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
                    return
                }
                if (event) {
                    event.preventDefault()
                }
                return AgreementService.open(id)
            }

            $scope.$on(AgreementConst.eventUpdate, () => this.load())
        }
    })
